


import API from "../../API";
import { call, put, select } from 'redux-saga/effects';
import {loadHbIndexChartDataError, loadHbIndexChartDataSuccess} from "./hb-index-chart-action-creators";

const getScore = filters => {
  let score = "";
  filters.forEach(filter => {
    if (filter.isScore) {
      score = filter.filter_name;
    }
  });
  return score;
};



export function* loadHbIndexChartData() {

  const reportUrl = yield select(state => state.report.reportUrl);
  const filters = yield select(state => state.filters.filtersToSend);
  const rawFilters = yield select(state => state.filters.filters);
  const score = getScore(rawFilters);
  try {
    const result = yield call(API.loadHbIndexData, { reportUrl, filters, score });
    console.log(result, 'RESULT FROM HB INDEX CHART LOAD DATA');
    if (result.data && result.data.results && result.data.results.length) {
      const { data, radio, selectedRadio } = normalize(result.data.results);
      yield put(loadHbIndexChartDataSuccess({ data, radio, selectedRadio }));
    } else {
      yield put(loadHbIndexChartDataError("No data"))
    }
  } catch(error) {
    console.log(error, 'ERROR FROM HB INDEX CHART LOAD DATA');
    yield put(loadHbIndexChartDataError("Something went wrong..."));
  }
}


const normalize = data => {
  const result = {};
  data.forEach(d => {
    const scoreLengthes = [];
    d.hb_indexes.forEach(hb_index => {
      scoreLengthes.push(hb_index.score.length);
      if (!hb_index.score) {
        hb_index.score = "unspecified";
      }
    });
    let max = Math.max(...scoreLengthes);
    max > 60 ? max = 60 : null;
    d.hb_indexes.max = max;
    result[d.header] = d.hb_indexes
  });
  const radio = Object.keys(result);
  const selectedRadio = radio[0];
  return {
    data: result,
    radio,
    selectedRadio
  };
};


// WEBPACK FOOTER //
// ./src/modules/hb-index-chart/hb-index-chart-saga.js